import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const Profile = props => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path
        d="M5 17.5c0-1.79 1.62-3.32 4-4.05a4.9 4.9 0 006.06 0c2.35.73 4 2.26 4 4.05v.16a9 9 0 10-14 0C5 17.61 5 17.55 5 17.5zm7-12a4 4 0 11-4 4 4 4 0 014-4z"
        fill="none"
      />
      <path d="M16.73 20.81l.21-.12a10 10 0 10-9.9 0l.21.12A8.9 8.9 0 0011 21.94c.33 0 .65.05 1 .05s.66 0 1-.05h.06a8.9 8.9 0 003.67-1.13zM3 12a9 9 0 1116 5.66v-.16c0-1.79-1.62-3.32-4-4.05a4.9 4.9 0 01-6.06 0c-2.35.73-4 2.26-4 4.05v.16A9 9 0 013 12z" />
      <circle cx="12" cy="9.5" r="4" />
    </SvgIcon>
  );
};

export default Profile;
